import { css } from '@repo/panda/css';
import type React from 'react';
import { useState } from 'react';

export const SubcategoryCardImage = ({ imageUrl }: { imageUrl: string | null }): React.JSX.Element | null => {
    const [imageError, setImageError] = useState(false);

    if (!imageUrl || imageError) {
        return null;
    }

    return (
        <img
            loading="lazy"
            src={imageUrl}
            alt=""
            className={css({
                position: 'absolute',
                top: '0',
                left: '0',
                width: '[80px]',
                height: '[80px]',
                objectFit: 'cover',
                borderRadius: '12',
                borderBottomRightRadius: 'none',
                borderTopRightRadius: 'none',
                filter: '[brightness(0.5)]',
                pointerEvents: 'none',
            })}
            onError={() => setImageError(true)}
        />
    );
};
